<template>
  <div class="vue-form">
    <div class="vld-parent">
            <loading :active.sync="isLoading" loader= 'bars' 
            :can-cancel="true" 
            :on-cancel="onCancel"
            :is-full-page="fullPage"></loading>
    </div>
    <form  @submit.prevent="submit" enctype="multipart/form-data">
      <fieldset>
        <legend><strong>Booking Form</strong></legend>
        <div class="row">
          Name <span class="required">*</span> :
          <input type="text" name="name" id="name" required="" v-model="name" placeholder="Name" maxlength="40">
        </div>  
        <!-- <div class="row">
          Name :<input type="text" name="name" id="name" required="" v-model="name" placeholder="Name" maxlength="40">
        </div> -->

        <div class="row">
          Email <span class="required">*</span> :<input type="email" name="email" id="email" required="" placeholder="Email"
                :class="{ email , error: !email.valid }"
                v-model="email.value" maxlength="40">
        </div>
        <div class="row">
          Phone :
          <input type="text" name="phone" id="phone" placeholder="Contact Number" v-model="phone" maxlength="100"/>
        </div>
        <div class="row">
          No of Adults <span class="required">*</span> :
          <select v-model="noofadults" required="">
              <option selected>0</option>
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
              <option>6</option>
              <option>7</option>
              <option>8</option>
              <option>9</option>
            </select>
        </div> 
        <div class="row">
          No of Children <span class="required">*</span> :
          <select v-model="noofchilds" required="">
              <option selected>0</option>
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
              <option>6</option>
              <option>7</option>
              <option>8</option>
              <option>9</option>
            </select>
        </div>
        <div class="row">
          Amout Paid(£) <span class="required">*</span> :
          <input type="number" name="amountpaid" id="amountpaid" required="" v-model="amountpaid" placeholder="Amount Paid in GBP" min="5" max="1000">
        </div> 
        <div class="row">
          Date of Transfer <span class="required">*</span> :
          <input type="date" name="dateoftransfer" id="dateoftransfer" required="" v-model="dateoftransfer" placeholder="Date of Bank Transfer">
        </div> 
        <div class="row">
          Description <span class="required">*</span> :
          <textarea  name="emailbody" id="description" required="" placeholder="Mention the event name, date and time for which you are filling up this form" v-model="description"/>
        </div>  
        <div class="row" style="display:none">
          Attachment of bank transfer screenshot (png or jpg,size less than 2 MB) :
          <file-base64 
                v-bind:multiple="false"
                v-bind:done="getFiles" accept=".png,.jpg,.jpeg">
          </file-base64>
        </div>  
        <div class="row">
          <div class="col-sm-4"></div>
          <div class="col-sm-8"><my-captcha :callSuccess="captchaBtn" resolve="text"  ></my-captcha>
              <div class="error-message" v-show="!email.valid">
                <p v-show="!email.valid">Invalid email address.</p>
              </div>
              <div class="success-message" v-show="emailsentstatus">
                <p v-show="emailsentstatus">{{emailsentstatusmessage}}</p>
              </div>
              <div class="error-message" v-show="!emailsentstatus && emailsentstatus!==''">
                <p v-show="!emailsentstatus && emailsentstatusmessage!==''">{{emailsentstatusmessage}}</p>
              </div> 
              <div class="error-message" v-show="!submitstatus">
                <p v-show="!submitstatus && submitstatusmessage!==''">{{submitstatusmessage}}</p>
              </div>  
            </div>
        </div>
        <div class="row">
          <div class="col-sm-4"></div>
          <div class="col-sm-8">
            <br/>
            <input type="submit" value="Submit" v-bind:disabled="btndis" class="button" style="color:#fff">
          </div>
        </div>
      </fieldset>  
    </form>
  </div>
</template>
 
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
//import myCaptcha from 'vue-captcha'
import myCaptcha from '@/components/sections/vue-captcha'
import axios from 'axios';
import fileBase64 from 'vue-file-base64'
var emailRegExp = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export default {
  name: 'Eventticket',
  components: {
    'my-captcha': myCaptcha,
    Loading,
    fileBase64 
  },
  data () {
    return {
      isLoading: false,
      fullPage: true,
      btndis: true,
      name : '',
      email: {
        value: '',
        valid: true
      },
      phone:'',
      submitted:false,
      emailsentstatus:'',
      emailsentstatusmessage:'',
      submitstatus:false,
      submitstatusmessage:'',
      
      noofadults:'',
      noofchilds:'',
      amountpaid:'',
      dateoftransfer:null,
      description : '',
      file: ''
      
    }
  },
  methods: {
    onCancel() {
              console.log('User cancelled the loader.')
            },
    getFiles(files){
        console.log(files);
        //this.description=files.base64;
        if(files.file.size>200000)
        {
          this.submitstatus=false;
          this.submitstatusmessage="Attachment too large";
        }
        else if(files.file.type!=="image/png" && files.file.type!=="image/jpeg")
        {// && !files.file.type==="image/jpeg"
          this.submitstatus=false;
          this.submitstatusmessage="File type should be png or jpg";
        }
        else
        {
          this.submitstatus=true;
          this.submitstatusmessage="";
          this.file=files;
        }
      },
    // submit form handler
    submit: function() {
      if(this.submitstatus || this.file==="")
      {
        this.submitted = true;
        this.emailsentstatusmessage='';
        this.isLoading = true;
        axios.post(process.env.NODE_API + '/eventticket', {
          contactname: this.name,
          contactemail: this.email.value,
          contactphone: this.phone,
          noofadults: this.noofadults,
          noofchilds: this.noofchilds,
          amountpaid:this.amountpaid,
          dateoftransfer:this.dateoftransfer,
          contactdescription: this.description,
          attachmentbase64:(this.file==="")?"": this.file.base64,
          attachmentname: (this.file==="")?"": this.file.name
        }
        
        )
        .then(response => {
          this.emailsentstatusmessage=response.data;
          //alert("Response Back");
          if(response.status===200)
            {
              this.emailsentstatus=true;
              this.btndis= true;
            }
          else 
            {
              this.emailsentstatus=false;   
              this.btndis= false;
            } 
        })
        .catch(function (error) {
          console.log(error);
        }).finally(() => this.isLoading = false);
      }


    },
    handleFileUpload(){
      this.file = this.$refs.file.files[0];
      alert(this.file.name + "-" + this.file.size + "-" + this.file.type);
       var reader = new FileReader();
       // Closure to capture the file information.
        reader.onload = (function(theFile) {
          return function(e) {
            var binaryData = e.target.result;
            //Converting Binary Data to base 64
            var base64String = window.btoa(binaryData);
            //showing file converted to base64
            //this.description = base64String;
            document.getElementById('description').value = base64String;
            //console.log(base64String);
            alert('File converted to base64 successfuly!\nCheck in Textarea');
            
          };
        })(this.file);
        // Read in the image file as a data URL.
        reader.readAsBinaryString(this.file);
        console.log(this.description);
    },
    captchaOk () {
      console.log('captcha ok.!')
    },
    captchaBtn () {
     this.btndis = false
    },
    clicked () {
      //alert('button active.!');
      this.submitted=true;
    },
    // validate by type and value
    validate: function(type, value) {
      
      if (type === "email") {
        //alert(this.isEmail(value))
        this.email.valid = this.isEmail(value) ? true : false;
        
      }
    },
    // check for valid email adress
    isEmail: function(value) {
      return emailRegExp.test(value);
    },
    
  },
  watch: {
    // watching nested property
    "email.value": function(value) {
      this.validate("email", value);
    }
  }
  
}
</script> 
 
<style scope>
  .form {
    margin: 10px;
  }
  .row {
    margin: 10px;
    color: #000;
  }
  .button {
    margin-top: 5px;
    background-color: #1D9D74;
    /* background-color: #000; */
    border: 1px solid transparent;
    border-radius: 3px;
    border-color: #dbdbdb;
    text-align: center;
    font-size: 1em;
    height: 2.25em;
    line-height: 1.5;
    color: white;
    cursor: pointer;
    padding-bottom: calc(0.375em - 1px);
    padding-left: calc(0.625em - 1px);
    padding-right: calc(0.625em - 1px);
    padding-top: calc(0.375em - 1px);
  }
  .button[disabled] {
    cursor: not-allowed;
    opacity: 0.6;
  }  
  /* .options
  {
    display: block;
  } 
  .content-text
  {
    display: block;
  }*/
  @import url("https://fonts.googleapis.com/css?family=Source+Code+Pro:300,400");

*,
*::after,
*::before {
  box-sizing: border-box;
}


.vue-form {
  font-size: 16px;
  width: 500px;
  padding: 15px 30px;
  border-radius: 4px;
  margin: 50px auto;
  /* width: 500px; */
  width: auto;
  background-color: #fff;
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
}
.vue-form fieldset {
  margin: 24px 0 0 0;
}
.vue-form legend {
  padding-bottom: 10px;
  border-bottom: 1px solid #ecf0f1;
  color:#000;
}
.vue-form div {
  position: relative;
  /* margin: 20px 0; */
}
.vue-form h4,
.vue-form .label {
  color: #94aab0;
  margin-bottom: 10px;
}
.vue-form .label {
  display: block;
}
.vue-form input,
.vue-form textarea,
.vue-form select,
.vue-form label {
  /* color: #2b3e51; */
  color: #000;
}
.vue-form input[type="file"]
{
  color: #000;
}
.vue-form input[type="text"],
.vue-form input[type="email"],
.vue-form input[type="number"],
.vue-form input[type="date"],
.vue-form textarea,
.vue-form select,
.vue-form legend {
  display: block;
  width: 100%;
  appearance: none;
}
.vue-form input[type="text"],
.vue-form input[type="email"],
.vue-form input[type="number"],
.vue-form input[type="date"],
.vue-form textarea,
.vue-form select {
  padding: 12px;
  border: 1px solid #cfd9db;
  background-color: #ffffff;
  border-radius: 0.25em;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.08);
}
.vue-form input[type="text"]:focus,
.vue-form input[type="email"]:focus,
.vue-form input[type="number"]:focus,
.vue-form input[type="date"]:focus,
.vue-form textarea:focus,
.vue-form select:focus {
  outline: none;
  border-color: #2c3e50;
  box-shadow: 0 0 5px rgba(44, 151, 222, 0.2);
}
.vue-form .select {
  position: relative;
}
.vue-form .select::after {
  content: "";
  position: absolute;
  z-index: 1;
  right: 16px;
  top: 50%;
  margin-top: -8px;
  display: block;
  width: 16px;
  height: 16px;
  background: url("data:image/svg+xml;charset=utf-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3C%21DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%0D%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0D%0A%09%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2016%2016%22%20enable-background%3D%22new%200%200%2016%2016%22%20xml%3Aspace%3D%22preserve%22%3E%0D%0A%3Cg%3E%0D%0A%09%3Cpolygon%20fill%3D%22%232c3e50%22%20points%3D%220.9%2C5.5%203.1%2C3.4%208%2C8.3%2012.9%2C3.4%2015.1%2C5.5%208%2C12.6%20%09%22%2F%3E%0D%0A%3C%2Fg%3E%0D%0A%3C%2Fsvg%3E")
    no-repeat center center;
  pointer-events: none;
}
.vue-form select {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.vue-form select::-ms-expand {
  display: none;
}
.vue-form .vue-form-list {
  margin-top: 16px;
}
.vue-form .vue-form-list::after {
  clear: both;
  content: "";
  display: table;
}
.vue-form .vue-form-list li {
  display: inline-block;
  position: relative;
  user-select: none;
  margin: 0 26px 16px 0;
  float: left;
}
.vue-form input[type="radio"],
.vue-form input[type="checkbox"] {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  margin: 0;
  padding: 0;
  opacity: 0;
  z-index: 2;
}
.vue-form input[type="radio"] + label,
.vue-form input[type="checkbox"] + label {
  padding-left: 24px;
}
.vue-form input[type="radio"] + label::before,
.vue-form input[type="radio"] + label::after,
.vue-form input[type="checkbox"] + label::before,
.vue-form input[type="checkbox"] + label::after {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -8px;
  width: 16px;
  height: 16px;
}
.vue-form input[type="radio"] + label::before,
.vue-form input[type="checkbox"] + label::before {
  border: 1px solid #cfd9db;
  background: #ffffff;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.08);
}
.vue-form input[type="radio"] + label::before,
.vue-form input[type="radio"] + label::after {
  border-radius: 50%;
}
.vue-form input[type="checkbox"] + label::before,
.vue-form input[type="checkbox"] + label::after {
  border-radius: 0.25em;
}
.vue-form input[type="radio"] + label::after,
.vue-form input[type="checkbox"] + label::after {
  background-color: #2c3e50;
  background-position: center center;
  background-repeat: no-repeat;
  box-shadow: 0 0 5px rgba(44, 151, 222, 0.4);
  display: none;
}
.vue-form input[type="radio"] + label::after {
  background-image: url("data:image/svg+xml;charset=utf-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3C%21DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%0D%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0D%0A%09%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2016%2016%22%20enable-background%3D%22new%200%200%2016%2016%22%20xml%3Aspace%3D%22preserve%22%3E%0D%0A%3Ccircle%20fill%3D%22%23FFFFFF%22%20cx%3D%228%22%20cy%3D%228%22%20r%3D%223%22%2F%3E%0D%0A%3C%2Fsvg%3E");
}
.vue-form input[type="checkbox"] + label::after {
  background-image: url("data:image/svg+xml;charset=utf-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3C%21--%20Generator%3A%20Adobe%20Illustrator%2018.1.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0D%0A%3C%21DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%0D%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0D%0A%09%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2016%2016%22%20enable-background%3D%22new%200%200%2016%2016%22%20xml%3Aspace%3D%22preserve%22%3E%0D%0A%3Cpolyline%20fill%3D%22none%22%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22square%22%20stroke-miterlimit%3D%2210%22%20points%3D%225%2C8%207%2C10%2011%2C6%20%22%2F%3E%0D%0A%3C%2Fsvg%3E");
}
.vue-form input[type="radio"]:focus + label::before,
.vue-form input[type="checkbox"]:focus + label::before {
  box-shadow: 0 0 5px rgba(44, 151, 222, 0.6);
}
.vue-form input[type="radio"]:checked + label::after,
.vue-form input[type="checkbox"]:checked + label::after {
  display: block;
}
.vue-form input[type="radio"]:checked + label::before,
.vue-form input[type="radio"]:checked + label::after,
.vue-form input[type="checkbox"]:checked + label::before,
.vue-form input[type="checkbox"]:checked + label::after {
  animation: cd-bounce 0.3s;
}
.vue-form textarea {
  min-height: 120px;
  resize: vertical;
  overflow: auto;
}
/* .vue-form input[type="submit"] {
  border: none;
  background: #2c3e50;
  border-radius: 0.25em;
  padding: 12px 20px;
  color: #ffffff;
  font-weight: bold;
  float: right;
  cursor: pointer;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  appearance: none;
} */
.no-touch .vue-form input[type="submit"]:hover {
  background: #42a2e1;
}
.vue-form input[type="submit"]:focus {
  outline: none;
  background: #2b3e51;
}
.vue-form input[type="submit"]:active {
  transform: scale(0.9);
}
.vue-form .error-message {
  /* height: 35px; */
  margin: 0px;
}
.vue-form .error-message p {
  background: #e94b35;
  color: #ffffff;
  font-size: 1.4rem;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border-radius: 0.25em;
  padding: 10px;
}
.vue-form .success-message {
  height: 35px;
  margin: 0px;
}
.vue-form .success-message p {
  background: #0a8f05;
  color: #ffffff;
  font-size: 1.4rem;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border-radius: 0.25em;
  padding: 10px;
}
.vue-form .error {
  border-color: #e94b35 !important;
}
.vue-form .counter {
  background-color: #ecf0f1;
  position: absolute;
  right: 0px;
  top: 0px;
  font-size: 10px;
  padding: 4px;
}

.debug {
  border-radius: 4px;
  margin: 50px auto;
  width: 500px;
  background-color: #000;
  padding: 50px;
  background: rgba(0, 0, 0, 0.8);
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
}

.debug pre {
  color: #ffffff;
  font-size: 18px;
  line-height: 30px;
  font-family: "Source Code Pro", monospace;
  font-weight: 300;
  white-space: pre-wrap;
}
.required {
  color: red;
}

@-webkit-keyframes cd-bounce {
  0%,
  100% {
    -webkit-transform: scale(1);
  }
  50% {
    -webkit-transform: scale(0.8);
  }
}
@-moz-keyframes cd-bounce {
  0%,
  100% {
    -moz-transform: scale(1);
  }
  50% {
    -moz-transform: scale(0.8);
  }
}
@keyframes cd-bounce {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
}




</style> 


// WEBPACK FOOTER //
// src/components/sections/Eventticket.vue